<div
  data-at-event-item
  class="event-item__wrapper flex flex-row gap-[12px] justify-start items-start"
>
  <div data-at-event-identifier class="event-type gt-sm:flex-[5%] gt-sm:max-w-[5%]">
    <app-customer-identifier [uuid]="event.editedBy"></app-customer-identifier>
  </div>

  <div class="event-item__body flex flex-row lt-md:flex-col">
    <div class="event-item__info-wrapper flex flex-col justify-evenly items-start">
      <div class="event-item__headline">
        <div *ngIf="isDeviceError; else notificationMessage">
          <span>{{ getEventTitle() | translate }}:</span>
          <span data-at-errorCode> {{ getErrorCodeTranslation() }}</span>

          <div *ngrxLet="installationDetailsStore.device$ as device">
            <ng-container *ngIf="event.body.deviceId === '0'; else otherDevices">
              <span class="event-item__label" *ngIf="device.boilerSerial">
                {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.ID' | translate }}
                {{ device.boilerSerial | serialSpacing }}
              </span>
            </ng-container>
            <ng-template #otherDevices>
              <span>
                {{
                  gatewayStore.getDeviceRoles(event.body.deviceId) | async | translateDeviceByRoles
                }}
              </span>

              <ng-container
                *ngIf="getDeviceNameFeature(event.body.deviceId) | async | ready as deviceName"
              >
                <span class="event-item__label" *ngIf="deviceName.properties.name.value">
                  {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.DESC' | translate }}
                  {{ deviceName | value2: featurePropertyKey.name }}
                </span>
              </ng-container>

              <span class="event-item__label" *ngIf="event.body.deviceId">
                {{ '+INSTALLATIONS.INSTALLATION.EVENT_LOG.ID' | translate }}
                {{ eventDescriptionService.getDeviceName(event) }}
              </span>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="event-item__description">
        {{ getEventDescription() }}
      </div>
      <ng-container *ngIf="event.eventType === eventTypes.FEATURE_CHANGED">
        <div class="ml-4 lt-md:ml-0 font-semibold">
          <span *ngIf="notificationEvent?.origin">
            {{ 'DIAGNOSTICS.CONNECTION_REASON_FORM.REASON_DROPDOWN.LABEL' | translate }}:
            {{ notificationEvent.origin
            }}{{ notificationEvent.body.featureName.includes(featureNames.rooms) ? '.' : null }}
          </span>
          <span *ngIf="notificationEvent.body.featureName.includes(featureNames.rooms)">
            <ng-container *ngrxLet="getRoom(notificationEvent.body.featureName) | async as room">
              {{ '+COMMISSIONING.ROOM.ALL_ADDED_DEVICES_MODAL.ROOM' | translate }}:
              {{
                room
                  ? (room | value2: featurePropertyKey.name)
                  : notificationEvent.body.commandBody.name
              }}
            </ng-container>
          </span>
        </div>
      </ng-container>
    </div>

    <div class="event-item__timestamp" data-at-timestamp>
      {{ createdTimestamp | date: 'short' }}
    </div>
  </div>
</div>

<ng-template #notificationMessage>
  <span>{{ getNotificationMessage() }}</span>
</ng-template>
